export default "__VITE_ASSET__Dkl_B5yG__"